var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7039 17.3631L21.4866 18.551C21.6594 18.6663 21.8698 18.711 22.0746 18.6759C22.2793 18.6409 22.4629 18.5287 22.5875 18.3625L25.025 15.1125L23.725 14.1375L21.7482 16.7732L19.9509 15.574C19.7755 15.4568 19.5613 15.4124 19.3537 15.4503C19.1461 15.4882 18.9613 15.6054 18.8386 15.7771L16.25 19.4017V13H14.625V21.125C14.6254 21.5558 14.7968 21.9689 15.1014 22.2736C15.4061 22.5782 15.8192 22.7496 16.25 22.75H24.375V21.125H17.0162L19.7039 17.3631Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 17.0625H13V18.6875H1.625V17.0625Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 21.125H13V22.75H1.625V21.125Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 13V8.9375H9.75C10.6116 8.93643 11.4376 8.59367 12.0469 7.98441C12.6562 7.37515 12.9989 6.54912 13 5.6875V3.25H10.5625C9.73048 3.25136 8.93104 3.57353 8.33056 4.14944C7.90982 3.3855 7.29194 2.74835 6.54128 2.30435C5.79062 1.86036 4.93464 1.62576 4.0625 1.625H1.625V4.0625C1.62651 5.35497 2.1406 6.59407 3.05452 7.50798C3.96843 8.4219 5.20753 8.93599 6.5 8.9375H7.3125V13H1.625V14.625H13V13H8.9375ZM10.5625 4.875H11.375V5.6875C11.3746 6.11834 11.2032 6.53142 10.8986 6.83607C10.5939 7.14073 10.1808 7.31207 9.75 7.3125H8.9375V6.5C8.93793 6.06916 9.10927 5.65608 9.41393 5.35143C9.71858 5.04677 10.1317 4.87543 10.5625 4.875ZM6.5 7.3125C5.63838 7.31143 4.81235 6.96867 4.20309 6.35941C3.59383 5.75015 3.25108 4.92412 3.25 4.0625V3.25H4.0625C4.92412 3.25108 5.75015 3.59383 6.35941 4.20309C6.96867 4.81235 7.31143 5.63838 7.3125 6.5V7.3125H6.5Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarDashboard);
export default __webpack_public_path__ + "static/media/navbar-dashboard.4e8e74f4.svg";
export { ForwardRef as ReactComponent };